/* global angular */
( function () {
	'use strict';

	function CategoryController ( logger, collectionService ) {
		var self = this;

		function avoidNullValue ( oldValue, newValue ) {
			if ( !newValue ) {
				newValue = oldValue;
			}

			return newValue;
		}

		function avoidDuplicateValue ( collection, model ) {
			var name = model.filterName;

			var isDuplicate = collection.some( function ( item ) {
				return item.filterName === model.filterName && item.filterId !== model.filterId;
			} );

			if ( isDuplicate ) {
				name = ( model.filterName ) + '1';
			}

			return name;
		}

		function addTag ( newTag ) {
			if ( newTag ) {
				var newObj = {
					'tagName' : newTag
				};

				collectionService.addModel( self.model.children, newObj );
			}
		}

		function removeTag ( tag ) {
			collectionService.removeModel( self.model.children, tag );
		}

		function validateCategoryName () {
			self.model.filterName = avoidNullValue( self.oldValue, self.model.filterName );
			self.model.filterName = avoidDuplicateValue( self.collection, self.model );
		}

		self.addTag               = addTag;
		self.removeTag            = removeTag;
		self.characterLimit       = 25;
		self.validateCategoryName = validateCategoryName;
	}

	angular
		.module( 'app.templates' )
		.controller( 'CategoryController', CategoryController );

	CategoryController.$inject = [ 'logger', 'collectionService' ];
} )( );
